<script>
import Slick from 'vue-slick'
// import 'slick-carousel/slick/slick.css'
// import { mapState } from 'vuex'

export default {
  components: {
    Slick,
  },
  props: {
    list: {
      type: Array,
      default: () => {},
    },
    firstAlias: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      type: 'exhibition',
      isMobile: false,
      showHamburger: false,
      slickOptions: {
        slidesToShow: 5, // 顯示個數
        slidesToScroll: 1, // 一次輪撥個數
        infinite: true, // 循環輪播
        touchThreshold: 3,
        arrows: false, // 箭頭
        pauseOnFocus: false,
        pauseOnHover: false,
        dots: false, // 底下點點
        centerMode: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      noProgress: true,
      slickProgress: 0,
      isPause: false,
      slickSpeed: 8000,
      innerSlickProgressClock: null,
    }
  },
  computed: {
    // ...mapState('techInside', {
    //   curationAlias: (state) => state.curationAlias,
    // }),
    // styleObject: function() {
    //   return {
    //     '--background-color': this.mainColor,
    //   }
    // },
  },
  created() {},
  mounted() {
    // this.runProgressClock()
    if (window.innerWidth < 992) {
      this.isMobile = true
    }
  },
  destroyed() {
    clearInterval(this.innerSlickProgressClock)
  },
  methods: {
    runProgressClock() {
      const timeout = 10
      this.innerSlickProgressClock = setInterval(() => {
        if (!this.isPause) {
          this.slickProgress += 100 / (this.slickSpeed / timeout)
          if (this.slickProgress >= 100) {
            this.slickProgress = 0
            if (this.$refs.slick) {
              this.onNext()
            }
          }
        }
      }, timeout)
    },
    onNext() {
      this.$refs.slick.next()
    },
    onPrev() {
      this.$refs.slick.prev()
    },
  },
}
</script>
<template>
  <div class="slider">
    <Slick ref="slick" :options="slickOptions">
      <div v-for="(item, index) of list" :key="`${item.title}-${index}`" ref="sliderShow" class="slider-box">
        <div class="box">
          <router-link v-if="!item.isFuture" :to="{ name: 'techInside-item', params: { alias: item.alias, aliastwo: firstAlias } }">
            <img v-if="item.featured === 1" :src="item.image.banner" alt="" class="imgHot" />
            <img v-else :src="item.image.banner" alt="" class="img" />
          </router-link>
          <template v-else>
            <img v-if="item.featured === 1" :src="item.image.banner" alt="" class="imgHot" />
            <img v-else :src="item.image.banner" alt="" class="img" />
          </template>
          <div class="content">
            <p class="icon"><img :src="item.icon" alt=""/></p>
            <p class="title">{{ item.title }}</p>
            <span class="colorLine" :style="{ background: item.color }"></span>
            <p v-if="!isMobile" class="desc"> {{ item.subtitle }}</p>
            <router-link v-if="!item.isFuture" :to="{ name: 'techInside-item', params: { alias: item.alias, aliastwo: firstAlias } }">
              <button class="more" :style="{ color: item.color, border: `1px solid ${item.color}` }">了解更多</button>
            </router-link>
            <template v-else>
              <button class="commingSoon" :style="{ backgroundColor: item.color }" disabled> coming soon</button>
            </template>
          </div>
        </div>
      </div>
    </Slick>
    <div v-if="list.length > 1" class="navigation">
      <button class="navigation__btn navigation__prev" @click="onPrev" @mouseenter="isPause = true" @mouseleave="isPause = false">
        <i class="navigation__icon fal fa-chevron-left"></i>
      </button>
      <button class="navigation__btn navigation__next" @click="onNext" @mouseenter="isPause = true" @mouseleave="isPause = false">
        <i class="navigation__icon fal fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.slider {
  position: relative;
  .slider-box {
    background-color: rgba(0, 0, 0, 0.502);
    position: relative;
    z-index: 1;
    scale: 1;
    transition: all 0.5s;
    &:hover {
      scale: 1.1;
      .more {
        opacity: 1;
      }
      .icon {
        opacity: 1;
      }
    }
  }
  .box {
    cursor: pointer;
    .img {
      width: 450px;
      height: 635px;
      transition: all 0.5s;
      filter: brightness(30%);
      @include max-xl {
        height: 500px;
      }
      @include max-md {
        width: 350px;
        height: 480px;
      }
      @include max-sm {
        width: 250px;
        height: 350px;
      }
    }
    .imgHot {
      position: relative;
      width: 450px;
      height: 635px;
      filter: opacity(95%);
      box-shadow: 10px 10px 20px #00000094;
      @include max-xl {
        height: 500px;
      }
      @include max-md {
        width: 350px;
        height: 480px;
      }
      @include max-sm {
        width: 250px;
        height: 350px;
      }
    }
  }
  .content {
    padding: 5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .icon {
      opacity: 0;
      width: 100px;
      height: 94px;
      transition: opacity 0.5s;
    }
    .title {
      text-align: center;
      font-size: 46px;
      color: $color-gray-1;
      word-break: keep-all;
      margin-top: 40px;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 400px;
      @include max-xl {
        font-size: 30px;
      }
      @include max-lg {
        font-size: 20px;
      }
      @media screen and (max-width: 400px) {
        max-width: 200px;
      }
    }
    .colorLine {
      display: inline-block;
      width: 85px;
      // background-color: aqua;
      height: 10px;
      border-radius: 10px;
      margin-bottom: 40px;
    }
    .desc {
      width: 320px;
      text-align: center;
      font-size: 18px;
      color: $color-gray-1;
      @include max-xl {
        // width: 180px;
        font-size: 16px;
      }
      @include max-lg {
        // width: 140px;
        font-size: 14px;
      }
    }
    .more {
      opacity: 0;
      width: 250px;
      height: 35px;
      border-radius: 25px;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.708);
      margin-top: 20px;
      transition: color 0.5s, background-color 0.5s, opacity 0.5s;
      @include max-sm {
        font-size: 14px;
        width: 120px;
        height: 25px;
      }
      &:hover {
        background-color: rgba(255, 255, 255, 0.97);
      }
    }
    .commingSoon {
      color: #fff;
      padding: 1px 6px;
      width: 250px;
      height: 35px;
      border-radius: 25px;
      margin-top: 20px;
      border: none;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      @include max-sm {
        font-size: 14px;
        width: 120px;
        height: 25px;
      }
    }
  }
  .appear {
    opacity: 1 !important;
    // &:hover {
    //   z-index: 5;
    //   scale: 1.1;
    // }
  }
  .scale {
    scale: 1.1;
    z-index: 5;
  }
  .light {
    filter: brightness(100%) !important;
  }
  .navigation {
    &__icon {
      background-color: $color-gray-1;
      color: $color-primary;
    }
    &__btn {
      position: absolute;
      top: 50%;
      z-index: 0;
      display: flex;
      width: calc(((100vw - #{$container-menu}) / 2) + 4rem);
      height: 100%;
      pointer-events: auto;
      background: transparent;
      border: unset;
      transform: translateY(-50%);
      appearance: none;

      @media screen and (max-width: $container-menu) {
        width: 100px;
      }

      &:focus {
        outline: none;
      }

      &:hover {
        .navigation {
          &__icon {
            color: #fff;
            background: $color-primary;
            border-color: $color-primary;
            opacity: 1;
            @include max-md {
              color: $color-primary;
              background: transparent;
              border-color: transparent;
              opacity: 1;
            }
          }
        }
      }

      &:active {
        outline: none;

        .navigation {
          &__icon {
            opacity: 0.75;
          }
        }
      }
    }

    &__prev {
      left: 0;
      align-items: center;
      justify-content: flex-end;

      @media screen and (max-width: $container-menu) {
        justify-content: flex-start;
        padding-left: 2rem;
      }
      @include max-md {
        padding-left: 10px;
      }
    }

    &__next {
      right: 0;
      align-items: center;
      justify-content: flex-start;

      @media screen and (max-width: $container-menu) {
        justify-content: flex-end;
        padding-right: 2rem;
      }
      @include max-md {
        padding-right: 10px;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      color: $color-primary;
      border: unset;
      border-radius: 100%;
      box-shadow: 0 32px 84px #0e567c2a;
      transition: border 0.3s, color 0.3s, background 0.3s;
      @include max-lg {
        width: 33px;
        height: 33px;
      }
      @include max-md {
        color: #8c97ab;
        border: 0;
        font-size: 20px;
        font-weight: 500;
        box-shadow: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.slick-list {
  overflow: visible !important;
}
.slick-slide {
  &:hover {
    .slide-box {
      scale: 1.1 !important;
    }
  }
}
.slick-center {
  position: relative !important;
  scale: 1.1 !important;
  z-index: 5 !important;
  .more {
    opacity: 1 !important;
  }
  .icon {
    opacity: 1 !important;
  }
}
</style>
